export interface ContactSearchResult {
  id?: number;
  name: string;
  direct_address: string;
  organization?: string;
  specialty?: string;
  source: 'local' | 'directory';
}

export class UpdoxContact {
  id: number;
  practice_id: number;
  name: string = '';
  direct_address: string = '';
  organization: string = '';
  specialty: string = '';
  auto_added: boolean = false;
  created_at: string;

  get initial(): string {
    return this.name ? this.name.charAt(0).toUpperCase() : '?';
  }

  get is_persisted(): boolean {
    return !!this.id;
  }

  load_from_json(json: any): UpdoxContact {
    if (!json) { return this; }
    this.id = json.id;
    this.practice_id = json.practice_id;
    this.name = json.name || '';
    this.direct_address = json.direct_address || '';
    this.organization = json.organization || '';
    this.specialty = json.specialty || '';
    this.auto_added = json.auto_added || false;
    this.created_at = json.created_at;
    return this;
  }

  to_params() {
    return {
      updox_contact: {
        practice_id: this.practice_id,
        name: this.name,
        direct_address: this.direct_address,
        organization: this.organization,
        specialty: this.specialty,
        auto_added: this.auto_added,
      }
    };
  }
}
